import clsx from 'clsx';
// mantine
import { Avatar } from '@mantine/core';
// components
import DateTime from '@/modules/DateTime/components/DateTime';
import MarkdownMessage from '@/components/MarkdownMessage';
// utils
import { DATE_FORMAT } from '@/const';
import { getIntegrationLogo } from '@/modules/Integrations/Integrations.utils.ts';
// assets
import styles from '@/modules/Chat/components/UserMessage/UserMessage.module.css';

interface UserMessageProps {
    className?: string;
    content: string;
    datetime?: string;
    integrationIdn?: string | null;
    connectorIdn?: string | null;
    externalId?: string | null;
}

const UserMessage = ({
    className,
    content,
    datetime = '',
    integrationIdn,
    connectorIdn,
    externalId
}: UserMessageProps) => {
    return (
        <div className={clsx(styles.message, styles.user, className)}>
            {!!(integrationIdn && connectorIdn) && (
                <div className={styles.top}>
                    <div className={styles.contentWrapper}>
                        <Avatar
                            alt="vapi"
                            className="bg-white"
                            radius="xl"
                            size="xs"
                            src={getIntegrationLogo(integrationIdn)}
                        />

                        <div className={styles.idnContentWrapper}>
                            <div>{connectorIdn}</div>
                            <div>{externalId}</div>
                        </div>
                    </div>
                    {!!datetime && (
                        <div className={styles.datetime}>
                            <DateTime
                                format={DATE_FORMAT.FULL_12H_MS}
                                value={datetime}
                            />
                        </div>
                    )}
                </div>
            )}
            <MarkdownMessage>{content}</MarkdownMessage>
        </div>
    );
};

export default UserMessage;
